/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Legs3D, Legs3DRonde, LegsAxel, LegsBrago, LegsButterfly, LegsClassico, LegsCono, LegsDiamond, LegsEbonu, LegsEbonu3Double, LegsEbonu3DoubleEik, LegsEbonu3DoubleStaal, LegsEbonu3Eik, LegsEbonu3Staal, LegsEbonuEik, LegsEbonuStaal, LegsEbu, LegsElmo, LegsElmoDouble, LegsFalke, LegsFly, LegsHarper, LegsHarper3, LegsJulio3, LegsJulio4, LegsLivio, LegsLivioSchuin, LegsLivioSchuinEik, LegsLivioSchuinStaal, LegsMPootRecht, LegsMPootSchuin, LegsMadrid, LegsNewly, LegsNovaroDouble, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsNovaroEik, LegsNovaroStaal, LegsOdil3, LegsOdil4, LegsOslo, LegsOxford, LegsPapillon, LegsPapillonStrak, LegsPino, LegsRafino, LegsRobu, LegsRobuDouble, LegsRobuDoubleEik, LegsRobuDoubleStaal, LegsRobuEik, LegsRobuStaal, LegsRoia, LegsTPoot, LegsTPootRonde, LegsTrapezium, LegsTwist3, LegsTwist4, LegsUPoot, LegsWithOffset, LegsWithOffsetStandardDefault, LegsXPoot, Table, TopCircle, TopDanishOval, TopHalfCircle, TopHalfOval, TopOval, TopRectangle } from './model/index.js';
export const constants = {
    Top: {
        $ceramicRepeatRatio: 1000,
        $woodRepeatRatio: 500
    }
};
const TableExpressions = [
    '$price',
    '$productName',
    '$availableLegTypes',
    '$availableMaterials',
    '$descriptionHeight',
    '$heightOptions',
    '$topOptions',
    '$legOptions',
    '$top',
    '$legs'
];
const LegsExpressions = [
    '$price',
    '$availableMaterials',
    '$height',
    '$descriptionLegsColor',
    '$descriptionLegOffset',
    '$descriptionLegStyle',
    '$descriptionLegThickness',
    '$offsetY',
    '$table'
];
const LegsClassicoExpressions = [
    '$calculatedWidth',
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsFalkeExpressions = [
    '$size',
    '$objectName',
    '$height',
    '$violations'
];
const LegsWithDiameterExpressions = [
    '$diameter'
];
const LegsWithLengthExpressions = [
    '$length'
];
const LegsWithWidthExpressions = [
    '$width'
];
const TopExpressions = [
    '$availableColors',
    '$availableEdgeFinishes',
    '$availableFenixVariants',
    '$availableLegTypes',
    '$availableThicknesses',
    '$availableTopFinishes',
    '$basePrice',
    '$price',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$descriptionDimensions',
    '$descriptionEdgeFinish',
    '$descriptionFenixVariant',
    '$descriptionMaterial',
    '$descriptionShape',
    '$descriptionTopColor',
    '$descriptionTopFinish',
    '$offsetY',
    '$materialToOverride',
    '$materialColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$roughness',
    '$normalScale',
    '$envMapIntensity',
    '$repeatX',
    '$repeatY',
    '$thicknessOptions',
    '$edgeFinishOptions',
    '$topFinishOptions',
    '$fenixVariantOptions',
    '$topMaterialOptions',
    '$table',
    '$ceramicRepeatRatio',
    '$woodRepeatRatio'
];
const TopCircleExpressions = [
    '$availableDiameters',
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$diameterOptions',
    '$violations'
];
const TopWithLengthAndWidthExpressions = [
    '$morphLength',
    '$lengthOptions',
    '$widthOptions'
];
const Legs3DExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const Legs3DRondeExpressions = [
    '$objectName',
    '$diameter',
    '$height',
    '$violations'
];
const LegsAxelExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsBragoExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsButterflyExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsConoExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsDiamondExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsEbonuExpressions = [
    '$length',
    '$width',
    '$height'
];
const LegsEbonu3Expressions = [
    '$diameter',
    '$height',
    '$offsetZ'
];
const LegsEbonu3DoubleExpressions = [
    '$length',
    '$height'
];
const LegsEbuExpressions = [
    '$objectName',
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsElmoExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsElmoDoubleExpressions = [
    '$length',
    '$height',
    '$violations'
];
const LegsFlyExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsHarperExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsHarper3Expressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsJulio3Expressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsJulio4Expressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsLivioExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsLivioSchuinExpressions = [
    '$length',
    '$width',
    '$height'
];
const LegsMadridExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsMPootRechtExpressions = [
    '$objectName',
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsMPootSchuinExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsNewlyExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsNovaroExpressions = [
    '$height'
];
const LegsNovaroDoubleExpressions = [
    '$length',
    '$height'
];
const LegsOsloExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsOdil3Expressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsOdil4Expressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsOxfordExpressions = [
    '$length',
    '$height',
    '$violations'
];
const LegsPapillonExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsPapillonStrakExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsPinoExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsRafinoExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsRobuExpressions = [
    '$diameter',
    '$height'
];
const LegsRobuDoubleExpressions = [
    '$length',
    '$height'
];
const LegsRoiaExpressions = [
    '$diameter',
    '$height',
    '$violations'
];
const LegsTPootExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsTPootRondeExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsTrapeziumExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsTwist3Expressions = [
    '$objectName',
    '$diameter',
    '$height',
    '$violations'
];
const LegsTwist4Expressions = [
    '$objectName',
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsUPootExpressions = [
    '$objectName',
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsXPootExpressions = [
    '$length',
    '$width',
    '$height',
    '$violations'
];
const LegsWithOffsetExpressions = [
    '$legOffsetOptions'
];
const LegsWithThicknessExpressions = [
    '$legThicknessOptions'
];
const SteelLegsExpressions = [
    '$materialColor',
    '$normalUrl',
    '$roughnessMapUrl',
    '$legsColorSwatches'
];
const OakLegsExpressions = [
    '$legsColorSwatches',
    '$materialColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl'
];
const TopDanishOvalExpressions = [
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$violations'
];
const TopHalfCircleExpressions = [
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$violations'
];
const TopHalfOvalExpressions = [
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$violations'
];
const TopOvalExpressions = [
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$violations'
];
const TopRectangleExpressions = [
    '$objectName',
    '$edgeFinishFacet',
    '$edgeFinishRound',
    '$violations'
];
const LegsEbonuEikExpressions = [
    '$violations'
];
const LegsEbonuStaalExpressions = [
    '$violations'
];
const LegsEbonu3EikExpressions = [
    '$violations'
];
const LegsEbonu3StaalExpressions = [
    '$violations'
];
const LegsEbonu3DoubleEikExpressions = [
    '$violations'
];
const LegsEbonu3DoubleStaalExpressions = [
    '$violations'
];
const LegsLivioSchuinEikExpressions = [
    '$violations'
];
const LegsLivioSchuinStaalExpressions = [
    '$violations'
];
const LegsNovaroEikExpressions = [
    '$violations'
];
const LegsNovaroStaalExpressions = [
    '$violations'
];
const LegsNovaroDoubleEikExpressions = [
    '$violations'
];
const LegsNovaroDoubleStaalExpressions = [
    '$violations'
];
const LegsRobuEikExpressions = [
    '$violations'
];
const LegsRobuStaalExpressions = [
    '$violations'
];
const LegsRobuDoubleEikExpressions = [
    '$violations'
];
const LegsRobuDoubleStaalExpressions = [
    '$violations'
];
export const $Table = new $DomainEntityReflection('Table', [
    ...TableExpressions
]);
export const $TopCircle = new $DomainEntityReflection('TopCircle', [
    ...TopCircleExpressions,
    ...TopExpressions
]);
export const $TopDanishOval = new $DomainEntityReflection('TopDanishOval', [
    ...TopDanishOvalExpressions,
    ...TopExpressions,
    ...TopWithLengthAndWidthExpressions
]);
export const $TopHalfCircle = new $DomainEntityReflection('TopHalfCircle', [
    ...TopHalfCircleExpressions,
    ...TopExpressions,
    ...TopWithLengthAndWidthExpressions
]);
export const $TopHalfOval = new $DomainEntityReflection('TopHalfOval', [
    ...TopHalfOvalExpressions,
    ...TopExpressions,
    ...TopWithLengthAndWidthExpressions
]);
export const $TopOval = new $DomainEntityReflection('TopOval', [
    ...TopOvalExpressions,
    ...TopExpressions,
    ...TopWithLengthAndWidthExpressions
]);
export const $TopRectangle = new $DomainEntityReflection('TopRectangle', [
    ...TopRectangleExpressions,
    ...TopExpressions,
    ...TopWithLengthAndWidthExpressions
]);
export const $Legs3D = new $DomainEntityReflection('Legs3D', [
    ...Legs3DExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $Legs3DRonde = new $DomainEntityReflection('Legs3DRonde', [
    ...Legs3DRondeExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...LegsWithThicknessExpressions,
    ...SteelLegsExpressions
]);
export const $LegsAxel = new $DomainEntityReflection('LegsAxel', [
    ...LegsAxelExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsBrago = new $DomainEntityReflection('LegsBrago', [
    ...LegsBragoExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsButterfly = new $DomainEntityReflection('LegsButterfly', [
    ...LegsButterflyExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsClassico = new $DomainEntityReflection('LegsClassico', [
    ...LegsClassicoExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsCono = new $DomainEntityReflection('LegsCono', [
    ...LegsConoExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...OakLegsExpressions
]);
export const $LegsDiamond = new $DomainEntityReflection('LegsDiamond', [
    ...LegsDiamondExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsEbonuEik = new $DomainEntityReflection('LegsEbonuEik', [
    ...LegsEbonuEikExpressions,
    ...LegsExpressions,
    ...LegsEbonuExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsEbonuStaal = new $DomainEntityReflection('LegsEbonuStaal', [
    ...LegsEbonuStaalExpressions,
    ...LegsExpressions,
    ...LegsEbonuExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsEbonu3Eik = new $DomainEntityReflection('LegsEbonu3Eik', [
    ...LegsEbonu3EikExpressions,
    ...LegsExpressions,
    ...LegsEbonu3Expressions,
    ...OakLegsExpressions
]);
export const $LegsEbonu3Staal = new $DomainEntityReflection('LegsEbonu3Staal', [
    ...LegsEbonu3StaalExpressions,
    ...LegsExpressions,
    ...LegsEbonu3Expressions,
    ...SteelLegsExpressions
]);
export const $LegsEbonu3DoubleEik = new $DomainEntityReflection('LegsEbonu3DoubleEik', [
    ...LegsEbonu3DoubleEikExpressions,
    ...LegsExpressions,
    ...LegsEbonu3DoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...OakLegsExpressions
]);
export const $LegsEbonu3DoubleStaal = new $DomainEntityReflection('LegsEbonu3DoubleStaal', [
    ...LegsEbonu3DoubleStaalExpressions,
    ...LegsExpressions,
    ...LegsEbonu3DoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsEbu = new $DomainEntityReflection('LegsEbu', [
    ...LegsEbuExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsElmo = new $DomainEntityReflection('LegsElmo', [
    ...LegsElmoExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...OakLegsExpressions
]);
export const $LegsElmoDouble = new $DomainEntityReflection('LegsElmoDouble', [
    ...LegsElmoDoubleExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...OakLegsExpressions
]);
export const $LegsFalke = new $DomainEntityReflection('LegsFalke', [
    ...LegsFalkeExpressions,
    ...LegsExpressions,
    ...SteelLegsExpressions
]);
export const $LegsFly = new $DomainEntityReflection('LegsFly', [
    ...LegsFlyExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsHarper = new $DomainEntityReflection('LegsHarper', [
    ...LegsHarperExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsHarper3 = new $DomainEntityReflection('LegsHarper3', [
    ...LegsHarper3Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsJulio3 = new $DomainEntityReflection('LegsJulio3', [
    ...LegsJulio3Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsJulio4 = new $DomainEntityReflection('LegsJulio4', [
    ...LegsJulio4Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsLivio = new $DomainEntityReflection('LegsLivio', [
    ...LegsLivioExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsLivioSchuinEik = new $DomainEntityReflection('LegsLivioSchuinEik', [
    ...LegsLivioSchuinEikExpressions,
    ...LegsExpressions,
    ...LegsLivioSchuinExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsLivioSchuinStaal = new $DomainEntityReflection('LegsLivioSchuinStaal', [
    ...LegsLivioSchuinStaalExpressions,
    ...LegsExpressions,
    ...LegsLivioSchuinExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsMadrid = new $DomainEntityReflection('LegsMadrid', [
    ...LegsMadridExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsMPootRecht = new $DomainEntityReflection('LegsMPootRecht', [
    ...LegsMPootRechtExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithThicknessExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsMPootSchuin = new $DomainEntityReflection('LegsMPootSchuin', [
    ...LegsMPootSchuinExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsNewly = new $DomainEntityReflection('LegsNewly', [
    ...LegsNewlyExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsNovaroEik = new $DomainEntityReflection('LegsNovaroEik', [
    ...LegsNovaroEikExpressions,
    ...LegsExpressions,
    ...LegsNovaroExpressions,
    ...OakLegsExpressions
]);
export const $LegsNovaroStaal = new $DomainEntityReflection('LegsNovaroStaal', [
    ...LegsNovaroStaalExpressions,
    ...LegsExpressions,
    ...LegsNovaroExpressions,
    ...SteelLegsExpressions
]);
export const $LegsNovaroDoubleEik = new $DomainEntityReflection('LegsNovaroDoubleEik', [
    ...LegsNovaroDoubleEikExpressions,
    ...LegsExpressions,
    ...LegsNovaroDoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...OakLegsExpressions
]);
export const $LegsNovaroDoubleStaal = new $DomainEntityReflection('LegsNovaroDoubleStaal', [
    ...LegsNovaroDoubleStaalExpressions,
    ...LegsExpressions,
    ...LegsNovaroDoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsOdil3 = new $DomainEntityReflection('LegsOdil3', [
    ...LegsOdil3Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsOdil4 = new $DomainEntityReflection('LegsOdil4', [
    ...LegsOdil4Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsOslo = new $DomainEntityReflection('LegsOslo', [
    ...LegsOsloExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...OakLegsExpressions
]);
export const $LegsOxford = new $DomainEntityReflection('LegsOxford', [
    ...LegsOxfordExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsPapillon = new $DomainEntityReflection('LegsPapillon', [
    ...LegsPapillonExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsPapillonStrak = new $DomainEntityReflection('LegsPapillonStrak', [
    ...LegsPapillonStrakExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...OakLegsExpressions
]);
export const $LegsPino = new $DomainEntityReflection('LegsPino', [
    ...LegsPinoExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsRafino = new $DomainEntityReflection('LegsRafino', [
    ...LegsRafinoExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsRobuEik = new $DomainEntityReflection('LegsRobuEik', [
    ...LegsRobuEikExpressions,
    ...LegsExpressions,
    ...LegsRobuExpressions,
    ...LegsWithDiameterExpressions,
    ...OakLegsExpressions
]);
export const $LegsRobuStaal = new $DomainEntityReflection('LegsRobuStaal', [
    ...LegsRobuStaalExpressions,
    ...LegsExpressions,
    ...LegsRobuExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsRobuDoubleEik = new $DomainEntityReflection('LegsRobuDoubleEik', [
    ...LegsRobuDoubleEikExpressions,
    ...LegsExpressions,
    ...LegsRobuDoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...OakLegsExpressions
]);
export const $LegsRobuDoubleStaal = new $DomainEntityReflection('LegsRobuDoubleStaal', [
    ...LegsRobuDoubleStaalExpressions,
    ...LegsExpressions,
    ...LegsRobuDoubleExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsRoia = new $DomainEntityReflection('LegsRoia', [
    ...LegsRoiaExpressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...SteelLegsExpressions
]);
export const $LegsTPoot = new $DomainEntityReflection('LegsTPoot', [
    ...LegsTPootExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsTPootRonde = new $DomainEntityReflection('LegsTPootRonde', [
    ...LegsTPootRondeExpressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsTrapezium = new $DomainEntityReflection('LegsTrapezium', [
    ...LegsTrapeziumExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsTwist3 = new $DomainEntityReflection('LegsTwist3', [
    ...LegsTwist3Expressions,
    ...LegsExpressions,
    ...LegsWithDiameterExpressions,
    ...LegsWithThicknessExpressions,
    ...SteelLegsExpressions
]);
export const $LegsTwist4 = new $DomainEntityReflection('LegsTwist4', [
    ...LegsTwist4Expressions,
    ...LegsExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithThicknessExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $LegsUPoot = new $DomainEntityReflection('LegsUPoot', [
    ...LegsUPootExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithThicknessExpressions,
    ...SteelLegsExpressions
]);
export const $LegsXPoot = new $DomainEntityReflection('LegsXPoot', [
    ...LegsXPootExpressions,
    ...LegsExpressions,
    ...LegsWithOffsetExpressions,
    ...LegsWithLengthExpressions,
    ...LegsWithWidthExpressions,
    ...SteelLegsExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Table.type,
    TopCircle.type,
    TopDanishOval.type,
    TopHalfCircle.type,
    TopHalfOval.type,
    TopOval.type,
    TopRectangle.type,
    Legs3D.type,
    Legs3DRonde.type,
    LegsAxel.type,
    LegsBrago.type,
    LegsButterfly.type,
    LegsClassico.type,
    LegsCono.type,
    LegsDiamond.type,
    LegsEbonuEik.type,
    LegsEbonuStaal.type,
    LegsEbonu3Eik.type,
    LegsEbonu3Staal.type,
    LegsEbonu3DoubleEik.type,
    LegsEbonu3DoubleStaal.type,
    LegsEbu.type,
    LegsElmo.type,
    LegsElmoDouble.type,
    LegsFalke.type,
    LegsFly.type,
    LegsHarper.type,
    LegsHarper3.type,
    LegsJulio3.type,
    LegsJulio4.type,
    LegsLivio.type,
    LegsLivioSchuinEik.type,
    LegsLivioSchuinStaal.type,
    LegsMadrid.type,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsNewly.type,
    LegsNovaroEik.type,
    LegsNovaroStaal.type,
    LegsNovaroDoubleEik.type,
    LegsNovaroDoubleStaal.type,
    LegsOdil3.type,
    LegsOdil4.type,
    LegsOslo.type,
    LegsOxford.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsPino.type,
    LegsRafino.type,
    LegsRobuEik.type,
    LegsRobuStaal.type,
    LegsRobuDoubleEik.type,
    LegsRobuDoubleStaal.type,
    LegsRoia.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTrapezium.type,
    LegsTwist3.type,
    LegsTwist4.type,
    LegsUPoot.type,
    LegsXPoot.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Table.type
]);
export const $Top = new EnhancedAliasReflection('$Top', [
    TopCircle.type,
    TopDanishOval.type,
    TopHalfCircle.type,
    TopHalfOval.type,
    TopOval.type,
    TopRectangle.type
]);
export const $TopWithLengthAndWidth = new EnhancedAliasReflection('$TopWithLengthAndWidth', [
    TopDanishOval.type,
    TopHalfCircle.type,
    TopHalfOval.type,
    TopOval.type,
    TopRectangle.type
]);
export const $Legs = new EnhancedAliasReflection('$Legs', [
    Legs3D.type,
    Legs3DRonde.type,
    LegsAxel.type,
    LegsBrago.type,
    LegsButterfly.type,
    LegsClassico.type,
    LegsCono.type,
    LegsDiamond.type,
    LegsEbonuEik.type,
    LegsEbonuStaal.type,
    LegsEbonu3Eik.type,
    LegsEbonu3Staal.type,
    LegsEbonu3DoubleEik.type,
    LegsEbonu3DoubleStaal.type,
    LegsEbu.type,
    LegsElmo.type,
    LegsElmoDouble.type,
    LegsFalke.type,
    LegsFly.type,
    LegsHarper.type,
    LegsHarper3.type,
    LegsJulio3.type,
    LegsJulio4.type,
    LegsLivio.type,
    LegsLivioSchuinEik.type,
    LegsLivioSchuinStaal.type,
    LegsMadrid.type,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsNewly.type,
    LegsNovaroEik.type,
    LegsNovaroStaal.type,
    LegsNovaroDoubleEik.type,
    LegsNovaroDoubleStaal.type,
    LegsOdil3.type,
    LegsOdil4.type,
    LegsOslo.type,
    LegsOxford.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsPino.type,
    LegsRafino.type,
    LegsRobuEik.type,
    LegsRobuStaal.type,
    LegsRobuDoubleEik.type,
    LegsRobuDoubleStaal.type,
    LegsRoia.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTrapezium.type,
    LegsTwist3.type,
    LegsTwist4.type,
    LegsUPoot.type,
    LegsXPoot.type
]);
export const $LegsEbonu = new EnhancedAliasReflection('$LegsEbonu', [
    LegsEbonuEik.type,
    LegsEbonuStaal.type
]);
export const $LegsEbonu3 = new EnhancedAliasReflection('$LegsEbonu3', [
    LegsEbonu3Eik.type,
    LegsEbonu3Staal.type
]);
export const $LegsEbonu3Double = new EnhancedAliasReflection('$LegsEbonu3Double', [
    LegsEbonu3DoubleEik.type,
    LegsEbonu3DoubleStaal.type
]);
export const $LegsLivioSchuin = new EnhancedAliasReflection('$LegsLivioSchuin', [
    LegsLivioSchuinEik.type,
    LegsLivioSchuinStaal.type
]);
export const $LegsNovaro = new EnhancedAliasReflection('$LegsNovaro', [
    LegsNovaroEik.type,
    LegsNovaroStaal.type
]);
export const $LegsNovaroDouble = new EnhancedAliasReflection('$LegsNovaroDouble', [
    LegsNovaroDoubleEik.type,
    LegsNovaroDoubleStaal.type
]);
export const $LegsRobu = new EnhancedAliasReflection('$LegsRobu', [
    LegsRobuEik.type,
    LegsRobuStaal.type
]);
export const $LegsRobuDouble = new EnhancedAliasReflection('$LegsRobuDouble', [
    LegsRobuDoubleEik.type,
    LegsRobuDoubleStaal.type
]);
export const $LegsWithDiameter = new EnhancedAliasReflection('$LegsWithDiameter', [
    Legs3DRonde.type,
    LegsCono.type,
    LegsElmo.type,
    LegsHarper3.type,
    LegsJulio3.type,
    LegsJulio4.type,
    LegsMadrid.type,
    LegsNewly.type,
    LegsOdil3.type,
    LegsOdil4.type,
    LegsOslo.type,
    LegsPino.type,
    ...LegsRobu.types,
    LegsRoia.type,
    LegsTwist3.type
]);
export const $LegsWithOffsetStandardDefault = new EnhancedAliasReflection('$LegsWithOffsetStandardDefault', [
    LegsBrago.type,
    LegsButterfly.type,
    LegsEbu.type,
    ...LegsEbonu3Double.types,
    LegsElmoDouble.type,
    ...LegsNovaroDouble.types,
    LegsOxford.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    ...LegsRobuDouble.types,
    LegsTrapezium.type,
    LegsUPoot.type,
    LegsXPoot.type
]);
export const $LegsWithOffset = new EnhancedAliasReflection('$LegsWithOffset', [
    LegsClassico.type,
    ...LegsWithOffsetStandardDefault.types
]);
export const $LegsWithLength = new EnhancedAliasReflection('$LegsWithLength', [
    Legs3D.type,
    LegsAxel.type,
    LegsDiamond.type,
    ...LegsEbonu.types,
    LegsFly.type,
    LegsHarper.type,
    LegsLivio.type,
    ...LegsLivioSchuin.types,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsRafino.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTwist4.type,
    ...LegsWithOffset.types
]);
export const $LegsWithThickness = new EnhancedAliasReflection('$LegsWithThickness', [
    Legs3DRonde.type,
    LegsMPootRecht.type,
    LegsTwist3.type,
    LegsTwist4.type,
    LegsUPoot.type
]);
export const $LegsWithWidth = new EnhancedAliasReflection('$LegsWithWidth', [
    Legs3D.type,
    LegsAxel.type,
    LegsBrago.type,
    LegsButterfly.type,
    LegsClassico.type,
    LegsDiamond.type,
    ...LegsEbonu.types,
    LegsEbu.type,
    LegsFly.type,
    LegsLivio.type,
    ...LegsLivioSchuin.types,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsRafino.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTrapezium.type,
    LegsTwist4.type,
    LegsXPoot.type
]);
export const $SteelLegs = new EnhancedAliasReflection('$SteelLegs', [
    Legs3D.type,
    Legs3DRonde.type,
    LegsAxel.type,
    LegsButterfly.type,
    LegsClassico.type,
    LegsDiamond.type,
    LegsEbonuStaal.type,
    LegsEbonu3Staal.type,
    LegsEbonu3DoubleStaal.type,
    LegsEbu.type,
    LegsFalke.type,
    LegsFly.type,
    LegsHarper.type,
    LegsHarper3.type,
    LegsJulio3.type,
    LegsJulio4.type,
    LegsLivioSchuinStaal.type,
    LegsMadrid.type,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsNewly.type,
    LegsNovaroStaal.type,
    LegsNovaroDoubleStaal.type,
    LegsOdil3.type,
    LegsOdil4.type,
    LegsOxford.type,
    LegsPino.type,
    LegsRafino.type,
    LegsRobuStaal.type,
    LegsRobuDoubleStaal.type,
    LegsRoia.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTrapezium.type,
    LegsTwist3.type,
    LegsTwist4.type,
    LegsUPoot.type,
    LegsXPoot.type
]);
export const $OakLegs = new EnhancedAliasReflection('$OakLegs', [
    LegsBrago.type,
    LegsCono.type,
    LegsEbonuEik.type,
    LegsEbonu3Eik.type,
    LegsEbonu3DoubleEik.type,
    LegsElmo.type,
    LegsElmoDouble.type,
    LegsLivio.type,
    LegsLivioSchuinEik.type,
    LegsNovaroEik.type,
    LegsNovaroDoubleEik.type,
    LegsOslo.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsRobuEik.type,
    LegsRobuDoubleEik.type
]);
export const $entityReflections = {
    Table: $Table,
    TopCircle: $TopCircle,
    TopDanishOval: $TopDanishOval,
    TopHalfCircle: $TopHalfCircle,
    TopHalfOval: $TopHalfOval,
    TopOval: $TopOval,
    TopRectangle: $TopRectangle,
    Legs3D: $Legs3D,
    Legs3DRonde: $Legs3DRonde,
    LegsAxel: $LegsAxel,
    LegsBrago: $LegsBrago,
    LegsButterfly: $LegsButterfly,
    LegsClassico: $LegsClassico,
    LegsCono: $LegsCono,
    LegsDiamond: $LegsDiamond,
    LegsEbonuEik: $LegsEbonuEik,
    LegsEbonuStaal: $LegsEbonuStaal,
    LegsEbonu3Eik: $LegsEbonu3Eik,
    LegsEbonu3Staal: $LegsEbonu3Staal,
    LegsEbonu3DoubleEik: $LegsEbonu3DoubleEik,
    LegsEbonu3DoubleStaal: $LegsEbonu3DoubleStaal,
    LegsEbu: $LegsEbu,
    LegsElmo: $LegsElmo,
    LegsElmoDouble: $LegsElmoDouble,
    LegsFalke: $LegsFalke,
    LegsFly: $LegsFly,
    LegsHarper: $LegsHarper,
    LegsHarper3: $LegsHarper3,
    LegsJulio3: $LegsJulio3,
    LegsJulio4: $LegsJulio4,
    LegsLivio: $LegsLivio,
    LegsLivioSchuinEik: $LegsLivioSchuinEik,
    LegsLivioSchuinStaal: $LegsLivioSchuinStaal,
    LegsMadrid: $LegsMadrid,
    LegsMPootRecht: $LegsMPootRecht,
    LegsMPootSchuin: $LegsMPootSchuin,
    LegsNewly: $LegsNewly,
    LegsNovaroEik: $LegsNovaroEik,
    LegsNovaroStaal: $LegsNovaroStaal,
    LegsNovaroDoubleEik: $LegsNovaroDoubleEik,
    LegsNovaroDoubleStaal: $LegsNovaroDoubleStaal,
    LegsOdil3: $LegsOdil3,
    LegsOdil4: $LegsOdil4,
    LegsOslo: $LegsOslo,
    LegsOxford: $LegsOxford,
    LegsPapillon: $LegsPapillon,
    LegsPapillonStrak: $LegsPapillonStrak,
    LegsPino: $LegsPino,
    LegsRafino: $LegsRafino,
    LegsRobuEik: $LegsRobuEik,
    LegsRobuStaal: $LegsRobuStaal,
    LegsRobuDoubleEik: $LegsRobuDoubleEik,
    LegsRobuDoubleStaal: $LegsRobuDoubleStaal,
    LegsRoia: $LegsRoia,
    LegsTPoot: $LegsTPoot,
    LegsTPootRonde: $LegsTPootRonde,
    LegsTrapezium: $LegsTrapezium,
    LegsTwist3: $LegsTwist3,
    LegsTwist4: $LegsTwist4,
    LegsUPoot: $LegsUPoot,
    LegsXPoot: $LegsXPoot
};

//# sourceMappingURL=enhanced-model.js.map